import { inject, Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { DeliveryAreaService } from '../delivery-area.service';

/**
 * The list of tabs on this page
 */
export enum DeliveryOverviewPageTabId {
	Overview = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum DeliveryOverviewPageViewId {
	// Overview = 1,
	AllVentures = 2,
	AllEntrepreneurs = 3,
	AllMentors = 4,
	VentureDropouts = 5,
	MentorDropouts = 6,
	SessionFeedback = 7,
	TopicFeedback = 8,
	SpecialistFeedback = 9,
	AllAwards = 10
}


@Injectable({ providedIn: 'root' })
export class DeliveryOverviewService extends PageTabsLayoutPageService<DeliveryOverviewPageTabId, DeliveryOverviewPageViewId> {

	public readonly areaService = inject(DeliveryAreaService);

	private static readonly _viewDroplistItems: DroplistItem<never, DeliveryOverviewPageViewId>[] = [
		// {
		// 	uniqueId: DeliveryOverviewPageViewId.Overview,
		// 	iconContext: {
		// 		iconClass: 'fa-grip-horizontal',
		// 		iconStyle: 'fa-solid',
		// 		text: 'Overview',
		// 		hideText: 'never',
		// 	},
		// 	groupName: 'Overview',
		// 	customSort: '1-Overview-1'
		// },
		{
			uniqueId: DeliveryOverviewPageViewId.AllVentures,
			iconContext: {
				iconClass: 'fa-user-group',
				iconStyle: 'fa-solid',
				text: 'All Ventures',
				hideText: 'never',
			},
			groupName: 'People',
			customSort: '2-People-1'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.AllEntrepreneurs,
			iconContext: {
				iconClass: 'fa-user-vneck',
				iconStyle: 'fa-solid',
				text: 'All Entrepreneurs',
				hideText: 'never',
			},
			groupName: 'People',
			customSort: '2-People-2'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.AllMentors,
			iconContext: {
				iconClass: 'fa-user-tie',
				iconStyle: 'fa-solid',
				text: 'All Mentors',
				hideText: 'never',
			},
			groupName: 'People',
			customSort: '2-People-3'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.VentureDropouts,
			iconContext: {
				iconClass: 'fa-user-slash',
				iconStyle: 'fa-solid',
				text: 'Venture Dropouts',
				hideText: 'never',
			},
			groupName: 'Dropouts',
			customSort: '3-Dropouts-1'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.MentorDropouts,
			iconContext: {
				iconClass: 'fa-user-slash',
				iconStyle: 'fa-solid',
				text: 'Mentor Dropouts',
				hideText: 'never',
			},
			groupName: 'Dropouts',
			customSort: '3-Dropouts-2'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.SessionFeedback,
			iconContext: {
				iconClass: 'fa-flip-horizontal fa-message-smile',
				iconStyle: 'fa-solid',
				text: 'Session Feedback',
				hideText: 'never',
			},
			groupName: 'Surveys',
			customSort: '4-Surveys-1'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.TopicFeedback,
			iconContext: {
				iconClass: 'fa-flip-horizontal fa-message-smile',
				iconStyle: 'fa-solid',
				text: 'Topic Feedback',
				hideText: 'never',
			},
			groupName: 'Surveys',
			customSort: '4-Surveys-2'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.SpecialistFeedback,
			iconContext: {
				iconClass: 'fa-flip-horizontal fa-message-smile',
				iconStyle: 'fa-solid',
				text: 'Specialist Feedback',
				hideText: 'never',
			},
			groupName: 'Surveys',
			customSort: '4-Surveys-3'
		},
		{
			uniqueId: DeliveryOverviewPageViewId.AllAwards,
			iconContext: {
				iconClass: 'fa-trophy',
				iconStyle: 'fa-solid',
				text: 'All Awards',
				hideText: 'never',
			},
			groupName: 'Graduation',
			customSort: '5-Graduation-1'
		},
	];
	constructor() {
		super(DeliveryOverviewService._viewDroplistItems, DeliveryOverviewService.name, DeliveryOverviewPageTabId.Overview, DeliveryOverviewPageViewId.AllVentures);
	}

	public get viewId() {
		return DeliveryOverviewPageViewId;
	}

}